'use client';

import { useEffect, useState } from 'react';

import { validateSerialNumberFormat } from '@/lib/serialNumber';
import { useLazyGetActiveBySerialQuery } from '@/services/warrantyApi';

const DEBOUNCE_MS = 500;
const MIN_LENGTH = 4;
const DAY_MS = 1000 * 60 * 60 * 24;

export const useWarrantySuggestion = (
  serialNumber: string,
  isLoggedIn: boolean
) => {
  const [trigger, { data: warranty }] = useLazyGetActiveBySerialQuery();
  const [dismissed, setDismissed] = useState(false);
  const [now] = useState(() => Date.now());

  useEffect(() => {
    if (!isLoggedIn) return;

    const value = serialNumber.trim();
    if (value.length < MIN_LENGTH) return;
    if (validateSerialNumberFormat(value)) return;

    const timer = setTimeout(
      () => trigger({ serialNumber: value }),
      DEBOUNCE_MS
    );
    return () => clearTimeout(timer);
  }, [serialNumber, isLoggedIn, trigger]);

  if (!warranty || dismissed) {
    return {
      warranty: null,
      remainingDays: 0,
      dismiss: () => setDismissed(true),
    };
  }

  const diff = Math.ceil((new Date(warranty.endDate).getTime() - now) / DAY_MS);

  return {
    warranty,
    remainingDays: diff > 0 ? diff : 0,
    dismiss: () => setDismissed(true),
  };
};
